import { css } from '@emotion/css';

export const tabScrollButtonStyles = css`
  .MuiSvgIcon-root {
    width: 20px;
    height: 20px;
  }
`;

// ref:https://stackoverflow.com/questions/20974276/prevent-safari-from-showing-tooltip-when-text-overflow-is-hidden-with-ellipsis
export const safariDoubleTooltipFix = css`
  &:before {
    content: '';
    display: block;
  }
`;

export const tabsRootStyles = css`
  div.MuiTabScrollButton-root:first-child {
    transform: translateX(-10px);
  }
`;

export const oulineNone = css`
  &:focus {
    outline: none;
  }
`;

export const tabStyles = css`
  ${oulineNone}
  input {
    cursor: pointer;
  }

  .Mui-focused {
    input {
      cursor: text;
    }
  }
`;

//TODO: fix left side fade in-out effect
export const scrollComponentStyles = css`
  ::before {
    content: '';
    display: block;
    width: 6rem;
    height: 4.8rem;
    background: linear-gradient(-90deg, rgba(252, 252, 252, 1) 0%, rgba(252, 252, 252, 0) 90%);
    position: absolute;
    right: 70%;
  }

  ::after {
    content: '';
    display: block;
    width: 12rem;
    height: 4.8rem;
    background: linear-gradient(90deg, rgba(252, 252, 252, 1) 0%, rgba(252, 252, 252, 0) 90%);
    position: absolute;
    left: 102%;
  }
`;
